export const REQUEST_PASSWORD_RESET = 'routes/Account/RequestPasswordReset/requestPasswordReset';

export const requestPasswordReset = (email, intl, history) => ({
    type: REQUEST_PASSWORD_RESET,
    payload: { intl, history, email },
});
